export enum SourceFromEnum{
    AGENT='AGENT',
    BUYER='BUYER',
    EMPLOYEE='EMPLOYEE'
}